import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { getProjects } from "../services";
import ProjectItems from "./projectItems";

const Projects = () => {
  const [loading, setLoading] = useState(true);
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    getProjects()
      .then((result) => {
        setProjects(result);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <div>
      {loading ? (
        <div className="load flex items-center justify-center">
          <div className="w-16 h-16 border-4 border-white border-solid rounded-full animate-spin"></div>
        </div>
      ) : (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <section className="">
            <div className="px-5 lg:px-20 mt-10 pb-10 w-full h-full grid gap-10 lg:grid-cols-2 xl:grid-cols-3 place-items-center">
              {projects.map((project, index) => (
                <ProjectItems project={project} key={index} />
              ))}
            </div>
          </section>
        </motion.div>
      )}
    </div>
  );
};

export default Projects;
